import { autoserializeAs } from 'cerialize';

export class ProxyCall implements IProxyCall {
  @autoserializeAs('session_sid') sessionSid?: string | null;
  @autoserializeAs('donor_proxy_number') donorProxyNumber?: string | null;
  @autoserializeAs('driver_proxy_number') driverProxyNumber?: string | null;
  @autoserializeAs('donor_number') donorNumber?: string | null;
  @autoserializeAs('driver_number') driverNumber?: string | null;
  @autoserializeAs('driver_user_id') driverUserId?: number | null;

  constructor(payload?: IProxyCall) {
    this.sessionSid = payload?.sessionSid;
    this.donorProxyNumber = payload?.donorProxyNumber;
    this.driverProxyNumber = payload?.driverProxyNumber;
    this.donorNumber = payload?.donorNumber;
    this.driverNumber = payload?.driverNumber;
    this.driverUserId = payload?.driverUserId;
  }
}

export interface IProxyCall {
  sessionSid?: string | null;
  donorProxyNumber?: string | null;
  driverProxyNumber?: string | null;
  donorNumber?: string | null;
  driverNumber?: string | null;
  driverUserId?: number | null;
}
